import { render, staticRenderFns } from "./AllTask.vue?vue&type=template&id=4de1a2ca&scoped=true"
import script from "./AllTask.vue?vue&type=script&lang=js"
export * from "./AllTask.vue?vue&type=script&lang=js"
import style0 from "./AllTask.vue?vue&type=style&index=0&id=4de1a2ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de1a2ca",
  null
  
)

export default component.exports